var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgUsers1 = function SvgUsers1(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    "data-width-12": 12,
    "data-width-16": 15,
    "data-width-20": 19,
    "data-width-24": 23,
    "data-width-28": 27,
    "data-width-72": 68,
    viewBox: "0 0 11.3 9.8",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M4.375 4.75a2.375 2.375 0 1 1 0-4.75 2.375 2.375 0 0 1 0 4.75m0-4a1.625 1.625 0 1 0 0 3.25 1.625 1.625 0 0 0 0-3.25m-4 9h8a.38.38 0 0 0 .375-.375A3.88 3.88 0 0 0 4.875 5.5h-1A3.88 3.88 0 0 0 0 9.375a.38.38 0 0 0 .375.375M7.98 9H.77a3.14 3.14 0 0 1 3.105-2.75h1A3.14 3.14 0 0 1 7.98 9m.358-2.531c1.27.417 2.076 1.772 2.076 2.916a.4.4 0 0 0 .8 0c0-1.444-.986-3.137-2.626-3.676a.4.4 0 0 0-.25.76M7.135.857c.632.191 1.09.807 1.09 1.525 0 .7-.442 1.275-1.115 1.525a.4.4 0 0 0 .28.75c.947-.352 1.635-1.202 1.635-2.275 0-1.053-.672-1.992-1.659-2.29a.4.4 0 0 0-.231.765",
    clipRule: "evenodd"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgUsers1);
export default ForwardRef;